module.exports = __webpack_public_path__ + "buste.png?eba037abc99e36e5b23bd0501c5f82ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buste.png
// module id = 130
// module chunks = 0